import React, { useEffect, useState } from "react";
import LabeledCheckbox from "../../TemplateProperties/TPCheckbox";
import { useTranslation } from "react-i18next";

const FormattingOptionsCheckboxes = ({ node, valuesHandler,callerComponent, hideControls, showQuoteData }) => {
	const { t } = useTranslation();
	const [trimData, setTrimData] = useState(false);
	const [quoteData, setQuoteData] = useState(false);
	const [urlEncode, setUrlEncode] = useState(false);
	const [reportTrancationError, setReportTrancationError] = useState(false);
	const [allowRoundingFloat, setAllowRoundingFloat] = useState(false);
	const [ignoreGlobalSubstitution, setIgnoreGlobalSubstitution] = useState(false);

	useEffect(() => {
		setTrimData(node?.TRIMDATA || "FALSE" );
		setQuoteData(node?.QUOTE_DATA || "FALSE" );
		setUrlEncode(node?.URLENCODE || "FALSE" );
		setReportTrancationError(node?.RPT_TRUNC_ERR || "TRUE" );
		setAllowRoundingFloat(node?.ROUND || "FALSE" );
		setIgnoreGlobalSubstitution(node?.IGNORE_GLOBAL_SUB || "FALSE" );
		// eslint-disable-next-line react-hooks/exhaustive-deps
	},[node?.key, node, node?.ROUND])


	return (
		<div className="flex flex-wrap">
			{hideControls?.includes("TRIMDATA") ? "" : <LabeledCheckbox
				checked={trimData === "TRUE"}
				handleCheck={(checked) => {
					setTrimData(checked ? "TRUE" : "FALSE")
					valuesHandler("TRIMDATA", checked ? "TRUE" : "FALSE");
				}}
				label={t("LBL_TRIM_DATA")}
			/>}

			{showQuoteData && <LabeledCheckbox 
				checked={quoteData === "TRUE"}
				handleCheck={(checked) => {
					setQuoteData(checked ? "TRUE" : "FALSE")
					valuesHandler("QUOTE_DATA", checked ? "TRUE" : "FALSE");
				}}
				label={t("BTN_QUOTE_DATA")}
			/>}

			{hideControls?.includes("URLENCODE") ? "" : <LabeledCheckbox
				checked={urlEncode === "TRUE"}
				handleCheck={(checked) => {
					setUrlEncode(checked ? "TRUE" : "FALSE");
					valuesHandler("URLENCODE", checked ? "TRUE" : "FALSE");

				}}
				label={t("BTN_URLENCODE_DATA")}
			/>}

			{
				["DATE", "FLOAT", "INTEGER", "PACKED_INT", "ZONED_INT"].includes(node?.FIELDTYPE) ||
				 hideControls?.includes("RPT_TRUNC_ERR") ? "" : <LabeledCheckbox
					checked={reportTrancationError === "TRUE" && !["DATE", "FLOAT", "INTEGER", "PACKED_INT", "ZONED_INT"].includes(node?.FIELDTYPE)}
					handleCheck={(checked) => {
						setReportTrancationError(checked ? "TRUE" : "FALSE");
						valuesHandler("RPT_TRUNC_ERR", checked ? "TRUE" : "FALSE")
					}}
					label={t("BTN_REPORT_TRUNCATION_ERRORS")}
				/>
			}

			{
				!["ALPHA", "DATE", "INTEGER", ...(callerComponent !== "IN_VALUES" ? ["ZONED_INT", "PACKED_INT"] : []), "BIT_FLAG"].includes(node?.FIELDTYPE) &&
				!hideControls?.includes("ROUND") ?  <LabeledCheckbox
					checked={allowRoundingFloat === "TRUE" && !["ALPHA", "DATE", "INTEGER", ...(callerComponent !== "IN_VALUES" ? ["ZONED_INT", "PACKED_INT"] : [])].includes(node?.FIELDTYPE)}
					handleCheck={(checked) => {
						setAllowRoundingFloat(checked ? "TRUE" : "FALSE");
						valuesHandler("ROUND", checked ? "TRUE" : "FALSE")
					}}
					label={t("BTN_ALLOW_ROUNDING_FOR_FLOAT")}
				/>:""
			}

			{(callerComponent === 'VCProperties' && node.FIELDTYPE === 'FLOAT') ? '' : (hideControls?.includes("IGNORE_GLOBAL_SUB") ? "" : <LabeledCheckbox
				checked={ignoreGlobalSubstitution === "TRUE"}
				handleCheck={(checked) => {
					setIgnoreGlobalSubstitution(checked ? "TRUE" : "FALSE");
					valuesHandler("IGNORE_GLOBAL_SUB", checked ? "TRUE" : "FALSE")
				}}
				label={t("IGNORE_GLOBAL_SUB")}
			/>)}
		</div>
	);
};

export default FormattingOptionsCheckboxes;
